export class FormModel {
  id: string = null;
  fullName: string;
  mobile: string;
  email: string;
  hospital: string;
  licenseType: number;
  licenseNumber: string;
  validDays: number;
  validDevices: number;
  isUsed: boolean;
  productId:string;
  productType:number;
  isPaymentPending:boolean;
  haLoginUsername:string;
}
